export default __webpack_public_path__ + "contactBackground.417fd0f.png";